(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  const pubsub = {
    events: {},
    on(event, cb) {
      (this.events[event] ||= []).push(cb);
    },
    emit(event, data) {
      (this.events[event] || []).forEach((cb) => cb(data));
    },
  };

  window.Skadeas = { pubsub };

  // Permanent setups discount: 10% off merchandise (shipping full).
  const SETUP_DISCOUNT_PERCENT = 10;
  const setupSaleActive = () => true;
  const setupSaleRate = () => 1 - SETUP_DISCOUNT_PERCENT / 100;

  const header = qs('[data-sk-header]');
  if (header) {
    const onScroll = () => {
      const transparent = header.dataset.transparent === 'true';
      header.classList.toggle('is-transparent', transparent);
      // Don't toggle scrolled styles on transparent homepage header —
      // that was causing the hero image to jump down on scroll.
      header.classList.toggle('is-scrolled', !transparent && window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const openDrawer = (id) => {
    const drawer = qs(`[data-drawer="${id}"]`);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (id === 'cart') document.documentElement.classList.add('sk-cart-open');
    const panel = drawer.querySelector('.sk-drawer__panel') || drawer;
    panel.querySelector('button:not([hidden]), [href], input, select, textarea')?.focus();
  };

  const closeDrawer = (id) => {
    const drawer = id ? qs(`[data-drawer="${id}"]`) : qs('.sk-drawer.is-open');
    if (!drawer) return;
    const closingCart = drawer.matches('[data-drawer="cart"]');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!qs('.sk-drawer.is-open')) document.documentElement.style.overflow = '';
    if (closingCart || !qs('[data-drawer="cart"].is-open')) {
      document.documentElement.classList.remove('sk-cart-open');
    }
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer(closer.dataset.drawerClose || undefined);
      return;
    }
    if (e.target.closest('.sk-drawer__overlay')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const policyPopup = qs('[data-custom-policy-popup]:not([hidden])');
    if (policyPopup) {
      policyPopup.hidden = true;
      return;
    }
    const bankModal = qs('[data-bank-offer-modal].is-open');
    if (bankModal) {
      bankModal.classList.remove('is-open');
      bankModal.hidden = true;
      return;
    }
    closeDrawer();
  });

  const formatMoney = (cents) => {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'PKR',
        maximumFractionDigits: 0,
      });
    } catch {
      return `Rs.${Math.round(cents / 100)}`;
    }
  };

  const syncCartFab = (count) => {
    const empty = count < 1;
    qsa('[data-cart-fab="header"]').forEach((el) => {
      el.hidden = !empty;
    });
    qsa('[data-cart-fab="float"]').forEach((el) => {
      el.hidden = empty;
      el.setAttribute('aria-label', empty ? 'Open cart' : `Open cart, ${count} items`);
    });
  };

  const updateCartCount = (count) => {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
      el.hidden = count < 1;
    });
    syncCartFab(count);
  };

  const escapeHtml = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const emptyCartHtml = () => {
    const shopUrl =
      qs('[data-cart-drawer]')?.dataset.collectionsUrl ||
      window.Shopify?.routes?.all_products_collection_url ||
      '/collections/all';
    return `<div class="sk-cart-empty">
      <p class="sk-cart-empty__title">Your cart is empty</p>
      <p class="sk-cart-empty__text">Add a board or accessories to get started.</p>
      <a class="sk-btn sk-btn--primary" href="${escapeHtml(shopUrl)}" data-drawer-close="cart">Continue shopping</a>
    </div>`;
  };

  const cartHasPackage = (cart) =>
    (cart?.items || []).some(
      (item) => item.properties && (item.properties.Package || item.properties.package)
    );

  // Products that cannot use Cash on Delivery (must use Bank Transfer).
  const PREPAID_ONLY_HANDLES = new Set([
    'skadeas-custom-plate-personalize-with-your-photo-logo-or-design',
    'skadeas-custom-pegboard',
  ]);

  const isCustomBoardItem = (item) => {
    if (!item) return false;
    const handle = String(item.handle || '').toLowerCase();
    if (handle === 'skadeas-custom-pegboard') return true;
    const props = item.properties || {};
    return props._custom_board === '1' || props.Custom === 'Custom pegboard';
  };

  const cartHasCustomBoard = (cart) => (cart?.items || []).some(isCustomBoardItem);

  const quotedCentsFromItem = (item) => {
    if (!item) return null;
    const props = item.properties || {};
    const raw = props._quoted_pkr ?? props.quoted_pkr;
    if (raw == null || raw === '') return null;
    const pkr = Number(String(raw).replace(/[^\d.]/g, ''));
    if (!Number.isFinite(pkr) || pkr <= 0) return null;
    return Math.round(pkr * 100);
  };

  const lineDisplayCents = (item) => {
    const quoted = quotedCentsFromItem(item);
    if (quoted != null) return quoted;
    return Number(item.final_line_price) || 0;
  };

  const isPrepaidOnlyItem = (item) =>
    PREPAID_ONLY_HANDLES.has(String(item?.handle || '').toLowerCase()) || isCustomBoardItem(item);

  const cartHasPrepaidOnly = (cart) => (cart?.items || []).some(isPrepaidOnlyItem);

  const cartIsMixedPrepaid = (cart) => {
    if (!cartHasPrepaidOnly(cart)) return false;
    return (cart.items || []).some((item) => {
      if (isPrepaidOnlyItem(item)) return false;
      if (item.properties && (item.properties.Package || item.properties.package)) return false;
      return true;
    });
  };

  const cartRequiresPrepaidCheckout = (cart) =>
    cartHasPackage(cart) ||
    cart.attributes?.package_order === 'true' ||
    cartHasPrepaidOnly(cart) ||
    cart.attributes?.prepaid_only === 'true';

  const cartAllowsBankTransferOffer = (cart) =>
    Boolean(cart?.items?.length) &&
    !cartHasPackage(cart) &&
    cart.attributes?.package_order !== 'true' &&
    !cartHasCustomBoard(cart);

  // Packages + prepaid-only products always use the Paid Bank Transfer page (no COD).
  const cartCanUseBankTransferPage = (cart) => {
    if (!cart?.items?.length) return false;
    if (cartRequiresPrepaidCheckout(cart)) return true;
    return true;
  };

  let packageAttrSync = Promise.resolve();
  const syncPackageOrderAttribute = (cart) => {
    if (!cart) return Promise.resolve(cart);
    const hasPackage = cartHasPackage(cart);
    const hasPrepaid = cartHasPrepaidOnly(cart);
    const attrs = cart.attributes || {};
    const flagged = attrs.package_order === 'true';
    const prepaidFlagged = attrs.prepaid_only === 'true';
    const paymentNote = attrs.Payment === 'Advance payment only';
    const bankOffer = attrs.bank_transfer_offer === 'true';
    const needsAdvance = hasPackage || hasPrepaid;
    const paymentMatches =
      (hasPackage && paymentNote) ||
      (!hasPackage && bankOffer && attrs.Payment === 'Bank transfer') ||
      (!hasPackage && hasPrepaid && !bankOffer && paymentNote) ||
      (!needsAdvance && !bankOffer && !attrs.Payment);
    if (
      hasPackage === flagged &&
      hasPrepaid === prepaidFlagged &&
      paymentMatches &&
      (!hasPackage || !bankOffer)
    ) {
      return Promise.resolve(cart);
    }

    packageAttrSync = packageAttrSync
      .catch(() => {})
      .then(async () => {
        const nextAttrs = {
          package_order: hasPackage ? 'true' : '',
          prepaid_only: hasPrepaid ? 'true' : '',
          // Keep bank-transfer offer payment note when BANK7 is active (incl. Custom Plate).
          Payment: hasPackage
            ? 'Advance payment only'
            : bankOffer
              ? 'Bank transfer'
              : hasPrepaid
                ? 'Advance payment only'
                : '',
        };
        if (hasPackage) nextAttrs.bank_transfer_offer = '';
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: nextAttrs }),
        });
        if (!res.ok) return cart;
        return res.json();
      });
    return packageAttrSync;
  };

  // Merchandise subtotal matching line prices (excludes cart-level codes like BANK7).
  // Custom pegboards use the quoted PKR stored on the line.
  const cartItemsSubtotal = (cart) => {
    if (!cart) return 0;
    if ((cart.items || []).some(isCustomBoardItem)) {
      return (cart.items || []).reduce((sum, item) => sum + lineDisplayCents(item), 0);
    }
    if (cart.items_subtotal_price != null) return Number(cart.items_subtotal_price) || 0;
    return (cart.items || []).reduce(
      (sum, item) => sum + (Number(item.final_line_price) || 0),
      0,
    );
  };

  const syncCartDrawerChrome = (cart) => {
    const empty = !cart?.items?.length;
    const isPackage = !empty && (cartHasPackage(cart) || cart.attributes?.package_order === 'true');
    const hasPrepaid = !empty && cartHasPrepaidOnly(cart);
    const hasCustomBoard = !empty && cartHasCustomBoard(cart);
    const mixedPrepaid = !empty && cartIsMixedPrepaid(cart);
    const requiresPrepaid = !empty && cartRequiresPrepaidCheckout(cart);
    const allowBankOffer = cartAllowsBankTransferOffer(cart);
    const allowBankPage = cartCanUseBankTransferPage(cart);
    const itemsSubtotal = cartItemsSubtotal(cart);
    const drawer = qs('[data-cart-drawer]');
    const footer = qs('[data-cart-footer]');
    const shipping = qs('[data-cart-shipping]');
    const countBadge = qs('[data-cart-drawer-count]');
    const clearBtn = qs('[data-cart-clear]');
    const checkoutBtn = qs('[data-cart-checkout]');
    const checkoutWrap = qs('[data-cart-checkout-wrap]');
    const footerTotal = qs('[data-cart-total]');
    const packageNote = qs('[data-cart-package-note]');
    const footerExtra = qs('[data-cart-footer-extra]');
    const bankBtn = qs('[data-bank-transfer-checkout]');
    const bankPrice = qs('[data-bank-transfer-price]');

    drawer?.classList.toggle('is-empty', empty);
    drawer?.classList.toggle('is-package', isPackage);
    drawer?.classList.toggle('is-prepaid', requiresPrepaid);
    if (footer) footer.hidden = empty;
    if (shipping) shipping.hidden = empty;
    if (clearBtn) clearBtn.hidden = empty;
    if (checkoutWrap) checkoutWrap.hidden = empty || requiresPrepaid;
    if (checkoutBtn) checkoutBtn.disabled = empty || requiresPrepaid;
    if (footerExtra) footerExtra.hidden = empty || requiresPrepaid;
    if (packageNote) {
      packageNote.hidden = empty || !requiresPrepaid;
      if (requiresPrepaid) {
        if (hasCustomBoard) {
          packageNote.textContent =
            'Custom orders are prepaid only — no Cash on Delivery and no discount. We appreciate your understanding.';
        } else if (isPackage && !hasPrepaid) {
          packageNote.textContent =
            'Advance payment only — COD is not available on setup packages. Shipping will be calculated later.';
        } else if (mixedPrepaid) {
          packageNote.textContent =
            'Your order contains products that are not available on Cash on Delivery. Please pay by Bank Transfer — save 7%.';
        } else if (hasPrepaid) {
          packageNote.textContent =
            'COD is not available for the Custom Plate. Pay by Bank Transfer and save 7%.';
        } else {
          packageNote.textContent =
            'Advance payment only — COD is not available for this cart. Please pay by Bank Transfer.';
        }
      }
    }
    if (bankBtn) {
      const showBank = !empty && (allowBankPage || requiresPrepaid);
      bankBtn.hidden = !showBank;
      if (showBank) bankBtn.removeAttribute('hidden');
    }
    const packageSaleOn = isPackage && setupSaleActive();
    // Custom Plate keeps 7% bank offer. Custom pegboard / packages do not.
    const showBankOffer = allowBankOffer && !isPackage && !hasCustomBoard;
    if (!empty && (allowBankPage || requiresPrepaid)) {
      const label = bankBtn?.querySelector('.sk-btn--bank__label');
      if (label) {
        if (showBankOffer) {
          label.textContent = 'Bank Transfer · 7% off';
        } else if (packageSaleOn) {
          label.textContent = `Pay with Bank Transfer · ${SETUP_DISCOUNT_PERCENT}% off`;
        } else {
          label.textContent = 'Pay with Bank Transfer';
        }
      }
    }
    if (showBankOffer) {
      const discounted = Math.round(itemsSubtotal * 0.93);
      const discountedLabel = formatMoney(discounted);
      if (bankPrice) bankPrice.textContent = discountedLabel;
      qsa('[data-bank-offer-modal-price], [data-bank-offer-modal-price-btn]').forEach((el) => {
        el.textContent = discountedLabel;
      });
    } else if (bankPrice) {
      // Packages: permanent setups merchandise discount. Custom board / otherwise full subtotal.
      const packageCents = packageSaleOn
        ? Math.round(itemsSubtotal * setupSaleRate())
        : itemsSubtotal;
      bankPrice.textContent =
        !empty && (allowBankPage || requiresPrepaid) ? formatMoney(packageCents) : '';
    }

    if (countBadge) {
      countBadge.textContent = String(cart?.item_count || 0);
      countBadge.hidden = empty;
    }

    if (footerTotal) {
      footerTotal.dataset.cents = String(itemsSubtotal);
      footerTotal.textContent = formatMoney(itemsSubtotal);
    }

    updateCartCount(cart?.item_count || 0);

    const progress = qs('[data-shipping-progress]');
    const threshold = Number(progress?.dataset.threshold || 0);
    if (!empty && progress && threshold > 0) {
      const pct = Math.min(100, Math.round((itemsSubtotal / threshold) * 100));
      progress.style.setProperty('--progress', `${pct}%`);
      const msg = qs('[data-shipping-message]');
      if (msg) {
        msg.textContent =
          itemsSubtotal >= threshold
            ? 'You have unlocked free shipping'
            : `${formatMoney(threshold - itemsSubtotal)} away from free shipping`;
      }
    }
  };

  const paintCartDrawer = (cart) => {
    const root = qs('[data-cart-drawer-body]');
    if (!root || !cart) return;

    syncCartDrawerChrome(cart);
    syncPackageOrderAttribute(cart).then((updated) => {
      if (updated && updated !== cart) syncCartDrawerChrome(updated);
    });

    if (!cart.items.length) {
      root.innerHTML = emptyCartHtml();
      return;
    }

    root.innerHTML = cart.items
      .map((item) => {
        const title = escapeHtml(item.product_title);
        const isCustomBoard = isCustomBoardItem(item);
        const displayCents = lineDisplayCents(item);
        const variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<p>${escapeHtml(item.variant_title)}</p>`
            : '';
        const props =
          item.properties && Object.keys(item.properties).length
            ? `<p class="sk-cart-line__props">${Object.entries(item.properties)
                .filter(([key]) => !String(key).startsWith('_'))
                .map(([key, value]) => `${escapeHtml(key)}: ${escapeHtml(value)}`)
                .join(' · ')}</p>`
            : '';
        const img = item.image
          ? `<img src="${escapeHtml(item.image)}" alt="${title}" width="72" height="72" loading="lazy">`
          : `<span class="sk-cart-line__placeholder" aria-hidden="true"></span>`;
        const qtyControls = isCustomBoard
          ? `<div class="sk-qty sk-qty--locked"><span>1</span></div>`
          : `<div class="sk-qty">
              <button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>
            </div>`;

        return `
      <article class="sk-cart-line" data-key="${escapeHtml(item.key)}" data-qty="${item.quantity}" data-line-price="${displayCents}">
        <a class="sk-cart-line__media" href="${escapeHtml(item.url)}">${img}</a>
        <div class="sk-cart-line__meta">
          <div class="sk-cart-line__top">
            <a href="${escapeHtml(item.url)}"><strong>${title}</strong></a>
            <button type="button" class="sk-cart-line__remove" data-cart-remove aria-label="Remove ${title}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>
            </button>
          </div>
          ${variant}
          ${props}
          <div class="sk-cart-line__row">
            ${qtyControls}
            <span class="sk-cart-line__price">${formatMoney(displayCents)}</span>
          </div>
        </div>
      </article>`;
      })
      .join('');
  };

  const renderCartDrawer = async () => {
    const res = await fetch('/cart.js');
    if (!res.ok) return;
    paintCartDrawer(await res.json());
  };

  let cartWrite = Promise.resolve();
  const changeLine = (key, quantity) => {
    cartWrite = cartWrite
      .catch(() => {})
      .then(async () => {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        if (!res.ok) throw new Error('cart change failed');
        const cart = await res.json();
        paintCartDrawer(cart);
        pubsub.emit('cart:updated', cart);
        return cart;
      });
    return cartWrite;
  };

  const clearCart = () => {
    cartWrite = cartWrite
      .catch(() => {})
      .then(async () => {
        const root = window.Shopify?.routes?.root || '/';
        let cart = null;

        // Prefer Shopify clear endpoint; fall back to zeroing every line.
        try {
          const res = await fetch(`${root}cart/clear.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
          });
          if (res.ok) cart = await res.json();
        } catch {
          /* fall through */
        }

        if (!cart || (cart.items && cart.items.length)) {
          const current = await fetch(`${root}cart.js`).then((r) => r.json());
          const updates = {};
          (current.items || []).forEach((item) => {
            updates[item.key] = 0;
          });
          const res = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              updates,
              attributes: {
                package_order: '',
                prepaid_only: '',
                bank_transfer_offer: '',
                Payment: '',
              },
            }),
          });
          if (!res.ok) throw new Error('cart clear failed');
          cart = await res.json();
        } else {
          try {
            cart = await setCartAttributes({
              package_order: '',
              prepaid_only: '',
              bank_transfer_offer: '',
              Payment: '',
            });
          } catch {
            /* attributes clear is best-effort */
          }
        }

        paintCartDrawer(cart);
        pubsub.emit('cart:updated', cart);
        return cart;
      });
    return cartWrite;
  };

  const setCartAttributes = async (attributes) => {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    });
    if (!res.ok) throw new Error('cart update failed');
    return res.json();
  };

  const bankOfferModal = () => qs('[data-bank-offer-modal]');

  const closeBankOfferModal = () => {
    const modal = bankOfferModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
  };

  const openBankOfferModal = (cart) => {
    const modal = bankOfferModal();
    if (!modal) return false;
    syncCartDrawerChrome(cart);
    modal.hidden = false;
    // Force reflow so the open transition runs
    void modal.offsetWidth;
    modal.classList.add('is-open');
    modal.querySelector('[data-bank-offer-accept]')?.focus();
    return true;
  };

  const goToNormalCheckout = async (checkoutBtn) => {
    if (checkoutBtn) checkoutBtn.disabled = true;
    closeBankOfferModal();
    try {
      await setCartAttributes({
        bank_transfer_offer: '',
        Payment: '',
        prepaid_only: '',
      });
    } catch {
      /* continue to checkout even if attribute clear fails */
    }
    const root = window.Shopify?.routes?.root || '/';
    window.location.href = `${root}checkout`;
  };

  const startBankTransferCheckout = async (triggerBtn, code = 'BANK7') => {
    const originalHtml = triggerBtn?.innerHTML;
    if (triggerBtn) {
      triggerBtn.disabled = true;
      triggerBtn.setAttribute('aria-busy', 'true');
    }
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      if (!cartCanUseBankTransferPage(cart)) {
        throw new Error('Bank transfer is not available for this cart.');
      }
      const withOffer = cartAllowsBankTransferOffer(cart);
      const updated = await setCartAttributes({
        bank_transfer_offer: withOffer ? 'true' : '',
        Payment: withOffer ? 'Bank transfer' : 'Advance payment only',
        package_order: cartHasPackage(cart) ? 'true' : '',
        prepaid_only: cartHasPrepaidOnly(cart) ? 'true' : '',
      });
      if (withOffer) {
        const attrs = updated?.attributes || {};
        if (attrs.bank_transfer_offer !== 'true') {
          throw new Error('Could not enable bank transfer offer on this cart.');
        }
      }
      const root = window.Shopify?.routes?.root || '/';
      // Custom Bank Transfer page creates the order as Paid via Cloudflare.
      // Set CUSTOM_BANK_TRANSFER_CHECKOUT = false to revert to native /checkout?discount=BANK7
      const CUSTOM_BANK_TRANSFER_CHECKOUT = true;
      if (CUSTOM_BANK_TRANSFER_CHECKOUT) {
        window.location.href = `${root}pages/bank-transfer`;
        return;
      }
      window.location.href = withOffer
        ? `${root}checkout?discount=${encodeURIComponent(code)}`
        : `${root}checkout`;
    } catch (err) {
      console.error(err);
      if (triggerBtn) {
        triggerBtn.disabled = false;
        triggerBtn.removeAttribute('aria-busy');
        if (originalHtml != null) triggerBtn.innerHTML = originalHtml;
      }
      window.alert(err?.message || 'Could not start bank transfer checkout. Please try again.');
      throw err;
    }
  };

  document.addEventListener('click', async (e) => {
    const bankDismiss = e.target.closest('[data-bank-offer-dismiss]');
    if (bankDismiss) {
      e.preventDefault();
      closeBankOfferModal();
      const checkoutBtn = qs('[data-cart-checkout]');
      if (checkoutBtn) checkoutBtn.disabled = false;
      return;
    }

    const bankDecline = e.target.closest('[data-bank-offer-decline]');
    if (bankDecline) {
      e.preventDefault();
      await goToNormalCheckout(qs('[data-cart-checkout]'));
      return;
    }

    const bankAccept = e.target.closest('[data-bank-offer-accept]');
    if (bankAccept) {
      e.preventDefault();
      if (bankAccept.disabled) return;
      const code = bankAccept.dataset.discountCode || 'BANK7';
      try {
        await startBankTransferCheckout(bankAccept, code);
      } catch {
        /* alert already shown */
      }
      return;
    }

    const bankRippleHost = e.target.closest('.sk-btn--bank');
    if (bankRippleHost && !bankRippleHost.disabled && !bankRippleHost.hidden) {
      const rect = bankRippleHost.getBoundingClientRect();
      bankRippleHost.style.setProperty('--sk-bank-x', `${e.clientX - rect.left}px`);
      bankRippleHost.style.setProperty('--sk-bank-y', `${e.clientY - rect.top}px`);
      bankRippleHost.classList.remove('is-rippling');
      void bankRippleHost.offsetWidth;
      bankRippleHost.classList.add('is-rippling');
      window.setTimeout(() => bankRippleHost.classList.remove('is-rippling'), 580);
    }

    const bankBtn = e.target.closest('[data-bank-transfer-checkout]');
    if (bankBtn) {
      e.preventDefault();
      if (bankBtn.disabled || bankBtn.hidden) return;
      const code = bankBtn.dataset.discountCode || 'BANK7';
      try {
        await startBankTransferCheckout(bankBtn, code);
      } catch {
        /* alert already shown */
      }
      return;
    }

    const clearBtn = e.target.closest('[data-cart-clear]');
    if (clearBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (clearBtn.disabled || clearBtn.hidden) return;

      // Optimistic empty state so it feels instant (confirm dialogs often fail in preview browsers)
      clearBtn.disabled = true;
      const root = qs('[data-cart-drawer-body]');
      syncCartDrawerChrome({ item_count: 0, total_price: 0, items_subtotal_price: 0, items: [] });
      if (root) root.innerHTML = emptyCartHtml();

      clearCart()
        .catch(() => {
          window.alert('Could not clear the cart. Please try again.');
          return renderCartDrawer();
        })
        .finally(() => {
          if (clearBtn.isConnected) clearBtn.disabled = false;
        });
      return;
    }

    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      const line = removeBtn.closest('.sk-cart-line');
      const key = line?.dataset.key;
      if (!key || line.classList.contains('is-removing')) return;

      // Optimistic remove — feel instant; sync from change.js response
      const linePrice = Number(line.dataset.linePrice || 0);
      const lineQty = Number(line.dataset.qty || 0);
      line.classList.add('is-removing');
      line.remove();

      const root = qs('[data-cart-drawer-body]');
      const countEl = qs('[data-cart-count]');
      const currentCount = Number(countEl?.textContent || 0);
      const nextCount = Math.max(0, currentCount - lineQty);
      const footerTotal = qs('[data-cart-total]');
      const nextTotal = Math.max(0, Number(footerTotal?.dataset.cents || 0) - linePrice);

      if (root && !qs('.sk-cart-line', root)) {
        syncCartDrawerChrome({ item_count: 0, total_price: 0, items_subtotal_price: 0, items: [] });
        root.innerHTML = emptyCartHtml();
      } else {
        updateCartCount(nextCount);
        const countBadge = qs('[data-cart-drawer-count]');
        if (countBadge) {
          countBadge.textContent = String(nextCount);
          countBadge.hidden = nextCount < 1;
        }
        if (footerTotal) {
          footerTotal.dataset.cents = String(nextTotal);
          footerTotal.textContent = formatMoney(nextTotal);
        }
      }

      changeLine(key, 0).catch(() => renderCartDrawer());
      return;
    }

    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const line = qtyBtn.closest('.sk-cart-line');
      if (!line || line.classList.contains('is-busy')) return;
      const span = line.querySelector('.sk-qty span');
      const next = Math.max(0, Number(span.textContent) + Number(qtyBtn.dataset.qtyChange));
      const key = line.dataset.key;
      line.classList.add('is-busy');
      if (next === 0) {
        line.classList.add('is-removing');
        line.remove();
        const root = qs('[data-cart-drawer-body]');
        if (root && !qs('.sk-cart-line', root)) {
          syncCartDrawerChrome({ item_count: 0, total_price: 0, items_subtotal_price: 0, items: [] });
          root.innerHTML = emptyCartHtml();
        }
      } else {
        span.textContent = String(next);
        line.dataset.qty = String(next);
      }
      changeLine(key, next)
        .catch(() => renderCartDrawer())
        .finally(() => line.isConnected && line.classList.remove('is-busy'));
    }
  });

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getFabTarget = () => qs('[data-cart-fab="float"]');

  const pulseCartFab = (fab) => {
    if (!fab) return;
    fab.classList.remove('is-receiving');
    // restart animation
    void fab.offsetWidth;
    fab.classList.add('is-receiving');
    window.setTimeout(() => fab.classList.remove('is-receiving'), 700);
  };

  const flyImageToCart = ({ sourceEl, imageUrl }) =>
    new Promise((resolve) => {
      const fab = getFabTarget();
      if (!sourceEl || !fab || prefersReducedMotion()) {
        pulseCartFab(fab);
        resolve();
        return;
      }

      // Ensure floater is measurable / visible as the landing target
      fab.hidden = false;

      const sourceRect = sourceEl.getBoundingClientRect();
      const fabRect = fab.getBoundingClientRect();
      if (sourceRect.width < 2 || fabRect.width < 2) {
        pulseCartFab(fab);
        resolve();
        return;
      }

      const size = Math.min(72, Math.max(44, Math.min(sourceRect.width, sourceRect.height) * 0.42));
      const startX = sourceRect.left + sourceRect.width / 2;
      const startY = sourceRect.top + sourceRect.height / 2;
      const endX = fabRect.left + fabRect.width / 2;
      const endY = fabRect.top + fabRect.height / 2;
      const deltaX = endX - startX;
      const deltaY = endY - startY;
      const arcLift = Math.min(140, Math.max(64, Math.abs(deltaY) * 0.35 + 48));

      const flyer = document.createElement('div');
      flyer.className = 'sk-cart-flyer';
      flyer.setAttribute('aria-hidden', 'true');
      flyer.style.width = `${size}px`;
      flyer.style.height = `${size}px`;
      flyer.style.left = `${startX}px`;
      flyer.style.top = `${startY}px`;
      if (imageUrl) {
        flyer.style.backgroundImage = `url(${JSON.stringify(imageUrl)})`;
      } else {
        flyer.classList.add('sk-cart-flyer--fallback');
      }
      document.body.appendChild(flyer);

      const motion = flyer.animate(
        [
          {
            transform: 'translate(-50%, -50%) scale(0.86)',
            opacity: 0,
            offset: 0,
          },
          {
            transform: 'translate(-50%, -50%) scale(1)',
            opacity: 1,
            offset: 0.12,
          },
          {
            transform: `translate(calc(-50% + ${deltaX * 0.42}px), calc(-50% + ${deltaY * 0.28 - arcLift}px)) scale(0.72)`,
            opacity: 1,
            offset: 0.55,
          },
          {
            transform: `translate(calc(-50% + ${deltaX}px), calc(-50% + ${deltaY}px)) scale(0.18)`,
            opacity: 0.35,
            offset: 1,
          },
        ],
        {
          duration: 820,
          easing: 'cubic-bezier(0.22, 0.61, 0.18, 1)',
          fill: 'forwards',
        }
      );

      motion.finished
        .catch(() => {})
        .finally(() => {
          flyer.remove();
          pulseCartFab(fab);
          resolve();
        });
    });

  const animateQuickAddToFab = async (form) => {
    const card = form.closest('.sk-product-card');
    const img = card?.querySelector('.sk-product-card__media img');
    const sourceEl = img || form.querySelector('[data-quick-add]') || form;
    const imageUrl = img?.currentSrc || img?.src || '';
    await flyImageToCart({ sourceEl, imageUrl });
  };

  document.addEventListener('submit', async (e) => {
    const checkoutForm = e.target.closest('.sk-cart-drawer__checkout');
    if (checkoutForm) {
      e.preventDefault();
      const btn = checkoutForm.querySelector('[data-cart-checkout]');
      if (btn?.disabled) return;
      if (btn) btn.disabled = true;
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        if (cartAllowsBankTransferOffer(cart) && openBankOfferModal(cart)) {
          if (btn) btn.disabled = false;
          return;
        }
      } catch (err) {
        console.error(err);
      }
      await goToNormalCheckout(btn);
      return;
    }

    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.noAjax === 'true') return;
    e.preventDefault();
    const quickAdd = Boolean(form.querySelector('[data-quick-add]'));
    const btn = form.querySelector('[data-quick-add], [type="submit"]');
    const original = btn?.textContent;
    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding…';
      btn.disabled = true;
    }
    try {
      const fd = new FormData(form);
      const res = await fetch(
        window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
        { method: 'POST', body: fd }
      );
      if (!res.ok) throw new Error('add failed');
      await renderCartDrawer();
      pubsub.emit('cart:updated');
      if (btn) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.textContent = 'Added';
      }
      if (quickAdd) {
        animateQuickAddToFab(form);
      } else {
        openDrawer('cart');
      }
      window.setTimeout(() => {
        if (!btn) return;
        btn.disabled = false;
        if (original) btn.textContent = original;
      }, 5000);
    } catch {
      if (btn) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        if (original) btn.textContent = original;
      }
    }
  });

  const searchInput = qs('[data-predictive-input]');
  const searchResults = qs('[data-predictive-results]');
  let searchTimer;
  if (searchInput && searchResults) {
    const runSearch = async (q) => {
      if (!q || q.length < 2) {
        searchResults.innerHTML = '';
        searchResults.hidden = true;
        return;
      }
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6`
      );
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      const collections = data.resources?.results?.collections || [];
      const articles = data.resources?.results?.articles || [];
      if (!products.length && !collections.length && !articles.length) {
        searchResults.innerHTML = `<p class="sk-predictive__empty">No results for “${q}”</p>`;
        searchResults.hidden = false;
        return;
      }
      searchResults.innerHTML = `
        ${
          products.length
            ? `<div class="sk-predictive__group"><h3>Products</h3>${products
                .map(
                  (p) => `<a class="sk-predictive__item" href="${p.url}">
          <img src="${p.image || ''}" alt="" width="48" height="48" loading="lazy">
          <span><strong>${p.title}</strong><small>${p.price}</small></span>
        </a>`
                )
                .join('')}</div>`
            : ''
        }
        ${
          collections.length
            ? `<div class="sk-predictive__group"><h3>Collections</h3>${collections
                .map((c) => `<a class="sk-predictive__item" href="${c.url}">${c.title}</a>`)
                .join('')}</div>`
            : ''
        }
        ${
          articles.length
            ? `<div class="sk-predictive__group"><h3>Articles</h3>${articles
                .map((a) => `<a class="sk-predictive__item" href="${a.url}">${a.title}</a>`)
                .join('')}</div>`
            : ''
        }
        <a class="sk-btn sk-btn--secondary sk-btn--full" href="/search?q=${encodeURIComponent(q)}">View all results</a>
      `;
      searchResults.hidden = false;
    };

    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => runSearch(searchInput.value.trim()), 180);
    });
  }

  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      updateCartCount(cart.item_count);
      renderCartDrawer();
    })
    .catch(() => {});

  qsa('[data-submenu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      const panel = qs(`#${btn.getAttribute('aria-controls')}`);
      if (panel) panel.hidden = expanded;
    });
  });

  // Setup packages: choose color, then add board + accessories to cart
  // package_order cart attribute disables COD at checkout (via payment customization)
  const SETUP_BOARDS = {
    White: 46632127824096, // Premium White Skadis 30" x 20"
    Black: 46647962206432, // Premium Black Skadis 30" x 20"
    Transparent: 46648512643296, // Transparent Skadis 30" x 20"
  };

  const SETUP_PACKAGES = {
    home_office: {
      title: 'Clean coding desk',
      board: SETUP_BOARDS,
      accessories: {
        White: [
          { id: 47594080927968, quantity: 1 }, // Skadis Hook set of 5 @ 535
          { id: 47704234033376, quantity: 1 }, // Pen Holder @ 660
          { id: 47704228561120, quantity: 1 }, // Headphones Holder @ 535
          { id: 47704232165600, quantity: 1 }, // Sticky Notes Holder @ 535
          { id: 47704228954336, quantity: 2 }, // Low weight shelf @ 1100
          { id: 53871693856992, quantity: 1 }, // Universal Remote Holder @ 900
          { id: 53871789146336, quantity: 1 }, // Universal Glasses Holder @ 1500
          { id: 53871781380320, quantity: 1 }, // Flower Pot Set @ 2500
        ],
        Black: [
          { id: 47594080960736, quantity: 1 },
          { id: 47704234066144, quantity: 1 },
          { id: 47704228593888, quantity: 1 },
          { id: 47704232198368, quantity: 1 },
          { id: 47704228987104, quantity: 2 },
          { id: 53871693824224, quantity: 1 },
          { id: 53871789113568, quantity: 1 },
          { id: 53871781347552, quantity: 1 },
        ],
      },
    },
    influencer: {
      title: 'Content creator desk',
      board: SETUP_BOARDS,
      accessories: {
        White: [
          { id: 47594080927968, quantity: 1 }, // Skadis Hook set of 5 @ 535
          { id: 47704234033376, quantity: 3 }, // Pen Holder @ 660
          { id: 47704222793952, quantity: 1 }, // Small Container @ 645
          { id: 47704228954336, quantity: 4 }, // Low weight shelf @ 1100
          { id: 53871693856992, quantity: 1 }, // Universal Remote Holder @ 900
          { id: 53871789146336, quantity: 1 }, // Universal Glasses Holder @ 1500
          { id: 53874039718112, quantity: 1 }, // Small Shelf @ 500
        ],
        Black: [
          { id: 47594080960736, quantity: 1 },
          { id: 47704234066144, quantity: 3 },
          { id: 47704222826720, quantity: 1 },
          { id: 47704228987104, quantity: 4 },
          { id: 53871693824224, quantity: 1 },
          { id: 53871789113568, quantity: 1 },
          { id: 53874039685344, quantity: 1 }, // Small Shelf @ 500
        ],
      },
    },
    kids: {
      title: "Kids' study table",
      board: SETUP_BOARDS,
      accessories: {
        White: [
          { id: 47704229806304, quantity: 2 }, // Photo holder @ 535
          {
            id: 47704234033376,
            quantity: 2,
            properties: { Type: 'Pen holder' },
          }, // Pen holder @ 660
          {
            id: 53871780331744,
            quantity: 3,
            properties: { Type: 'Big Pen holder' },
          }, // Custom Pen holder white @ 980
          { id: 47704228954336, quantity: 2 }, // Low weight shelf @ 1100
          { id: 47594080927968, quantity: 1 }, // Skadis hook set of 5 @ 535
          { id: 47704222793952, quantity: 2 }, // Small container @ 645
          { id: 47704232165600, quantity: 1 }, // Sticky Notes holder @ 535
        ],
        Black: [
          { id: 47704229839072, quantity: 2 },
          {
            id: 47704234066144,
            quantity: 2,
            properties: { Type: 'Pen holder' },
          },
          {
            id: 53871780298976,
            quantity: 3,
            properties: { Type: 'Big Pen holder' },
          }, // Custom Pen holder black @ 980
          { id: 47704228987104, quantity: 2 },
          { id: 47594080960736, quantity: 1 },
          { id: 47704222826720, quantity: 2 },
          { id: 47704232198368, quantity: 1 },
        ],
      },
    },
    basic_bundle: {
      title: 'Basic Bundle',
      board: SETUP_BOARDS,
      accessories: {
        White: [
          { id: 47704228954336, quantity: 1 }, // Low weight shelf @ 1100
          { id: 47704229806304, quantity: 1 }, // Photo holder @ 535
          { id: 47594080927968, quantity: 1 }, // Skadis Hook set of 5 @ 535
          { id: 47704232165600, quantity: 1 }, // Sticky Notes Holder @ 535
          { id: 47704234033376, quantity: 1 }, // Pen Holder @ 660
        ],
        Black: [
          { id: 47704228987104, quantity: 1 },
          { id: 47704229839072, quantity: 1 },
          { id: 47594080960736, quantity: 1 },
          { id: 47704232198368, quantity: 1 },
          { id: 47704234066144, quantity: 1 },
        ],
      },
    },
  };

  let activePackageId = null;
  const setupTitle = qs('#SkSetupPackageTitle');
  const setupAccessoryStep = qs('[data-setup-accessory-step]');
  const setupConfirm = qs('[data-setup-package-confirm]');

  const cartAddUrl = () =>
    window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js';

  const resolveProductVariantId = async (handle, color) => {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      const product = await res.json();
      const variants = product?.variants || [];
      if (!variants.length) return null;
      if (color) {
        const match = variants.find(
          (v) =>
            v.option1 === color ||
            v.title === color ||
            String(v.title).toLowerCase().includes(String(color).toLowerCase())
        );
        if (match) return match.id;
      }
      return variants[0].id;
    } catch {
      return null;
    }
  };

  const buildPackageItems = async (pkg, boardColor, accessoryColor) => {
    const packageName = pkg.title || 'Setup package';
    const boardId = pkg.board?.[boardColor];
    const accessories = pkg.accessories?.[accessoryColor] || [];
    const items = [];
    if (boardId) {
      items.push({
        id: Number(boardId),
        quantity: 1,
        properties: { Package: packageName },
      });
    }
    accessories.forEach((item) => {
      items.push({
        id: Number(item.id),
        quantity: Number(item.quantity) || 1,
        properties: { Package: packageName, ...(item.properties || {}) },
      });
    });

    for (const custom of pkg.customAccessories || []) {
      const color = custom.matchColor ? accessoryColor : null;
      const variantId = custom.id || (await resolveProductVariantId(custom.handle, color));
      if (!variantId) {
        throw new Error(
          `Product “${custom.handle}” is not available on the storefront. Create it, set it to Active, then try again.`
        );
      }
      items.push({
        id: Number(variantId),
        quantity: Number(custom.quantity) || 1,
        properties: { Package: packageName, ...(custom.properties || {}) },
      });
    }

    return items;
  };

  const setPackageOrderAttributes = async (enabled) => {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          package_order: enabled ? 'true' : '',
          Payment: enabled ? 'Advance payment only' : '',
        },
      }),
    });
    if (!res.ok) throw new Error('Could not flag package order');
    return res.json();
  };

  const syncAccessoryStep = () => {
    // Always ask for pegboard + accessory colors separately.
    if (setupAccessoryStep) setupAccessoryStep.hidden = false;
  };

  qsa('input[name="setup-package-color"]').forEach((input) => {
    input.addEventListener('change', syncAccessoryStep);
  });

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-setup-package]');
    if (!trigger) return;
    activePackageId = trigger.dataset.setupPackageId || null;
    if (!activePackageId || !SETUP_PACKAGES[activePackageId]) {
      activePackageId = null;
      return;
    }
    if (setupTitle) {
      setupTitle.textContent = `Choose colors — ${trigger.dataset.setupTitle || 'Setup'}`;
    }
    const white = qs('input[name="setup-package-color"][value="White"]');
    if (white) white.checked = true;
    const accWhite = qs('input[name="setup-accessory-color"][value="White"]');
    if (accWhite) accWhite.checked = true;
    syncAccessoryStep();
    openDrawer('setup-package');
  });

  setupConfirm?.addEventListener('click', async () => {
    const pkg = SETUP_PACKAGES[activePackageId];
    if (!pkg) return;
    const boardColor = qs('input[name="setup-package-color"]:checked')?.value || 'White';
    const accessoryColor =
      qs('input[name="setup-accessory-color"]:checked')?.value || 'White';

    const original = setupConfirm.textContent;
    setupConfirm.disabled = true;
    setupConfirm.textContent = 'Adding…';
    try {
      const items = await buildPackageItems(pkg, boardColor, accessoryColor);
      if (!items.length) throw new Error('package empty');
      const res = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('package add failed');
      await setPackageOrderAttributes(true);
      closeDrawer('setup-package');
      await renderCartDrawer();
      openDrawer('cart');
      pubsub.emit('cart:updated');
    } catch (err) {
      console.error(err);
      window.alert(err?.message || 'Could not add this package. Please try again or contact support.');
    } finally {
      setupConfirm.disabled = false;
      setupConfirm.textContent = original;
    }
  });

  // Custom pegboard order wizard (size → orientation → colour → finish → review)
  const PRICE_CALC_FEE = 1500;
  const PRICE_CALC_UNIT = 12;
  const PRICE_CALC_UNIT_SMALL = 11.0833;
  const PRICE_CALC_SMALL_MAX_SQIN = 600;
  const CUSTOM_BOARD_MIN_IN = 6;
  const CUSTOM_BOARD_MAX_LONG_IN = 72; /* 6 ft */
  const CUSTOM_BOARD_MAX_SHORT_IN = 48; /* 4 ft */
  const STANDARD_BOARD = { short: 20, long: 30, orientation: 'Horizontal' };
  const MATTE_STANDARD_PER_SIDE = 1500;
  const MATTE_CUSTOM_PER_SIDE = 650;
  const CUSTOM_BOARD_HANDLE = 'skadeas-custom-pegboard';
  const priceCalcDrawer = qs('[data-drawer="price-calc"]');
  const priceCalcLength = qs('[data-price-calc-length]');
  const priceCalcWidth = qs('[data-price-calc-width]');
  const priceCalcTotal = qs('[data-price-calc-total]');
  const customBoardPriceEl = qs('[data-custom-board-price]');
  const customShippingPriceEl = qs('[data-custom-shipping-price]');
  const customFeePriceEl = qs('[data-custom-fee-price]');
  const customFeeNoteEl = qs('[data-custom-fee-note]');
  const customFinishLabelEl = qs('[data-custom-finish-label]');
  const customFinishPriceEl = qs('[data-custom-finish-price]');
  const customFinishNoteEl = qs('[data-custom-finish-note]');
  const customMatteRateEl = qs('[data-custom-matte-rate]');
  const customSideOneEl = qs('[data-custom-side-one]');
  const customSideBothEl = qs('[data-custom-side-both]');
  const customMatteSidesEl = qs('[data-custom-matte-sides]');
  const customSizePriceEl = qs('[data-custom-size-price]');
  const customSizePriceValueEl = qs('[data-custom-size-price-value]');
  const customPolicyAck = qs('[data-custom-policy-ack]');
  const customPolicyPopup = qs('[data-custom-policy-popup]');
  const customPolicyTitle = qs('[data-custom-policy-title]');
  const customPolicyBody = qs('[data-custom-policy-body]');
  const customSpecsEl = qs('[data-custom-specs]');
  const customStepLabel = qs('[data-custom-step-label]');
  const customStepMeter = qs('[data-custom-step-meter]');
  const customStepMeterFill = qs('[data-custom-step-meter-fill]');
  const customErrorEl = qs('[data-custom-error]');
  const customAddBtn = qs('[data-custom-add-to-cart]');
  const buildSection = qs('[data-sk-build]');

  const formatPkr = (amount) =>
    `Rs. ${Math.round(amount).toLocaleString('en-PK')}`;

  const customState = {
    step: 'size',
    length: 0,
    width: 0,
    orientation: '',
    color: '',
    finish: '',
    sides: 0,
    total: 0,
    business: false,
  };

  const STEP_META = {
    size: { index: 1, label: 'Size' },
    orientation: { index: 2, label: 'Shape' },
    color: { index: 3, label: 'Colour' },
    finish: { index: 4, label: 'Finish' },
    review: { index: 5, label: 'Review' },
  };

  const policyCache = {};

  const showCustomStep = (step) => {
    customState.step = step;
    qsa('[data-custom-step]').forEach((el) => {
      el.hidden = el.getAttribute('data-custom-step') !== step;
    });
    updateStepMeter(step);
    if (customErrorEl) {
      customErrorEl.hidden = true;
      customErrorEl.textContent = '';
    }
  };

  const readDimension = (raw) => {
    const s = String(raw ?? '').trim();
    if (!s) return { empty: true };
    if (!/^\d+$/.test(s)) return { decimal: true };
    return { value: Number(s) };
  };

  const boardDimensionsOk = (length, width) => {
    if (!Number.isInteger(length) || !Number.isInteger(width)) return false;
    if (length < CUSTOM_BOARD_MIN_IN || width < CUSTOM_BOARD_MIN_IN) return false;
    const longSide = Math.max(length, width);
    const shortSide = Math.min(length, width);
    return longSide <= CUSTOM_BOARD_MAX_LONG_IN && shortSide <= CUSTOM_BOARD_MAX_SHORT_IN;
  };

  const currentDimensions = () => {
    const length = readDimension(priceCalcLength?.value);
    const width = readDimension(priceCalcWidth?.value);
    return { length, width };
  };

  const isSquareDimensions = (length, width) =>
    Number.isInteger(length) &&
    Number.isInteger(width) &&
    length === width &&
    boardDimensionsOk(length, width);

  const currentSquare = () => {
    const { length, width } = currentDimensions();
    if (length.value == null || width.value == null) return false;
    return isSquareDimensions(length.value, width.value);
  };

  const orderFlow = () =>
    currentSquare()
      ? ['size', 'color', 'finish', 'review']
      : ['size', 'orientation', 'color', 'finish', 'review'];

  const updateStepMeter = (step) => {
    const flow = orderFlow();
    const index = Math.max(1, flow.indexOf(step) + 1);
    const meta = STEP_META[step];
    if (customStepLabel && meta) {
      customStepLabel.textContent = `Step ${index} of ${flow.length} · ${meta.label}`;
    }
    if (customStepMeter) {
      customStepMeter.setAttribute('aria-valuemax', String(flow.length));
      customStepMeter.setAttribute('aria-valuenow', String(index));
      if (customStepMeterFill) customStepMeterFill.style.width = `${(index / flow.length) * 100}%`;
    }
  };

  const applySquareOrientation = () => {
    if (!currentSquare()) {
      if (customState.orientation === 'Square pegboard') customState.orientation = '';
      return false;
    }
    customState.orientation = 'Square pegboard';
    qsa('[data-custom-orientation]').forEach((el) => {
      el.checked = false;
    });
    return true;
  };

  const sizeValid = () => {
    const { length, width } = currentDimensions();
    if (length.value == null || width.value == null) return false;
    return boardDimensionsOk(length.value, width.value);
  };

  const sizeLimitMessage = () => {
    const { length, width } = currentDimensions();
    if (length.empty || width.empty) return '';
    if (length.decimal || width.decimal) return 'Use whole inches only. Decimals are not accepted.';
    if (length.value < CUSTOM_BOARD_MIN_IN || width.value < CUSTOM_BOARD_MIN_IN) {
      return 'Minimum size is 6 × 6 inches.';
    }
    if (boardDimensionsOk(length.value, width.value)) return '';
    return `Maximum size is 6 × 4 feet (72 × 48 inches). ${length.value}" × ${width.value}" is too large for us to make.`;
  };

  const isStandardBoard = (length, width, orientation) => {
    const shortSide = Math.min(length, width);
    const longSide = Math.max(length, width);
    return (
      shortSide === STANDARD_BOARD.short &&
      longSide === STANDARD_BOARD.long &&
      orientation === STANDARD_BOARD.orientation
    );
  };

  const boardPriceForArea = (area) => {
    const rate = area <= PRICE_CALC_SMALL_MAX_SQIN ? PRICE_CALC_UNIT_SMALL : PRICE_CALC_UNIT;
    return Math.round(area * rate);
  };

  const deliveryForArea = (area) => {
    if (area <= 600) return 450;
    if (area <= 1000) return 750;
    if (area <= 1500) return 1000;
    if (area <= 2000) return 1500;
    if (area <= 2500) return 2000;
    return 4000;
  };

  const quoteParts = () => {
    const length = customState.length;
    const width = customState.width;
    const standard = isStandardBoard(length, width, customState.orientation);
    const area = length * width;
    const board = boardPriceForArea(area);
    const delivery = customState.business ? 0 : deliveryForArea(area);
    const fee = customState.business ? 0 : standard ? 0 : PRICE_CALC_FEE;
    const perSide = standard ? MATTE_STANDARD_PER_SIDE : MATTE_CUSTOM_PER_SIDE;
    const sides = customState.finish === 'Matte' ? Number(customState.sides) || 0 : 0;
    const finishCharge = perSide * sides;
    return { standard, board, area, delivery, fee, perSide, sides, finishCharge, total: board + finishCharge + fee + delivery };
  };

  const customSizePreviewValue = qs('[data-custom-size-preview-value]');
  const customSizeLimitEl = qs('[data-custom-size-limit]');

  const syncSizePreview = () => {
    const { length, width } = currentDimensions();
    if (!customSizePreviewValue) return;
    if (length.value != null && width.value != null && sizeValid()) {
      customSizePreviewValue.textContent = `${length.value}" × ${width.value}"`;
      if (customSizePriceEl) customSizePriceEl.hidden = false;
      if (customSizePriceValueEl) {
        customSizePriceValueEl.textContent = formatPkr(boardPriceForArea(length.value * width.value));
      }
    } else {
      customSizePreviewValue.textContent = '—';
      if (customSizePriceEl) customSizePriceEl.hidden = true;
    }
  };

  const syncSizeContinue = () => {
    syncSizePreview();
    const valid = sizeValid();
    const limitMsg = sizeLimitMessage();
    if (customSizeLimitEl) {
      customSizeLimitEl.hidden = !limitMsg;
      customSizeLimitEl.textContent = limitMsg;
    }
    [priceCalcLength, priceCalcWidth].forEach((input) => {
      if (!input) return;
      const { length, width } = currentDimensions();
      const hasValues = !length.empty && !width.empty;
      const overLimit = hasValues && !sizeValid();
      input.setAttribute('aria-invalid', overLimit ? 'true' : 'false');
      input.closest('.sk-price-calc__input-wrap')?.classList.toggle('is-invalid', overLimit);
    });
    const nextBtn = qs('[data-custom-step="size"] [data-custom-next]');
    if (nextBtn) nextBtn.disabled = !valid;
    const squareNote = qs('[data-custom-square-note]');
    if (squareNote) squareNote.hidden = !(valid && currentSquare());
    if (customState.step === 'size') updateStepMeter('size');
  };

  const syncOrientationContinue = () => {
    if (applySquareOrientation()) {
      const nextBtn = qs('[data-custom-step="orientation"] [data-custom-next]');
      if (nextBtn) nextBtn.disabled = false;
      return;
    }
    const nextBtn = qs('[data-custom-step="orientation"] [data-custom-next]');
    const selected = qs('[data-custom-orientation]:checked');
    if (nextBtn) nextBtn.disabled = !selected;
    customState.orientation = selected?.value || '';
  };

  const syncFinishCopy = () => {
    const { perSide, standard } = quoteParts();
    if (customMatteRateEl) {
      customMatteRateEl.textContent = standard
        ? `${formatPkr(perSide)} per side. Customization fee is included.`
        : `${formatPkr(perSide)} per side.`;
    }
    if (customSideOneEl) customSideOneEl.textContent = `${formatPkr(perSide)} for one side.`;
    if (customSideBothEl) customSideBothEl.textContent = `${formatPkr(perSide * 2)} for both sides.`;
    if (customFinishNoteEl) {
      const show = customState.finish === 'Matte' || customState.finish === 'Glossy';
      customFinishNoteEl.hidden = !show;
      if (customState.finish === 'Glossy') {
        customFinishNoteEl.textContent = standard
          ? 'Glossy is free. A 30″ × 20″ horizontal board has no extra customization fee.'
          : 'Glossy is free. The Rs. 1,500 customization fee is added on the review step because this is not a 30″ × 20″ horizontal board.';
      } else if (customState.finish === 'Matte') {
        customFinishNoteEl.textContent = standard
          ? 'Matte is Rs. 1,500 per side on a 30″ × 20″ horizontal board. That price includes the customization fee.'
          : 'Matte is Rs. 650 per side. A separate Rs. 1,500 customization fee is added on the review step.';
      }
    }
  };

  const syncColorContinue = () => {
    const selected = qs('[data-custom-color]:checked');
    customState.color = selected?.value || '';
    const nextBtn = qs('[data-custom-step="color"] [data-custom-next]');
    if (nextBtn) nextBtn.disabled = !selected;
  };

  const syncFinishContinue = () => {
    const finish = qs('[data-custom-finish]:checked');
    const sides = qs('[data-custom-sides]:checked');
    customState.finish = finish?.value || '';
    customState.sides = customState.finish === 'Matte' ? Number(sides?.value) || 0 : 0;
    if (customMatteSidesEl) customMatteSidesEl.hidden = customState.finish !== 'Matte';
    syncFinishCopy();
    const ready = customState.finish === 'Glossy' || (customState.finish === 'Matte' && customState.sides > 0);
    const nextBtn = qs('[data-custom-step="finish"] [data-custom-next]');
    if (nextBtn) nextBtn.disabled = !ready;
  };

  const syncReviewAck = () => {
    const ackBox = customPolicyAck?.closest('.sk-price-calc__ack');
    const ackError = qs('[data-custom-ack-error]');
    if (customPolicyAck?.checked) {
      ackBox?.classList.remove('is-invalid');
      customPolicyAck.removeAttribute('aria-invalid');
      if (ackError) ackError.hidden = true;
    }
    if (customAddBtn && customAddBtn.textContent !== 'Adding…') customAddBtn.disabled = false;
  };

  const markPolicyAckError = () => {
    const ackBox = customPolicyAck?.closest('.sk-price-calc__ack');
    const ackError = qs('[data-custom-ack-error]');
    ackBox?.classList.add('is-invalid');
    customPolicyAck?.setAttribute('aria-invalid', 'true');
    if (ackError) ackError.hidden = false;
    customPolicyAck?.focus();
  };

  const computeCustomTotal = () => {
    const { length, width } = currentDimensions();
    customState.length = length.value || 0;
    customState.width = width.value || 0;
    syncOrientationContinue();
    syncFinishContinue();
    const quote = quoteParts();
    customState.total = quote.total;
    const finishText =
      customState.finish === 'Matte'
        ? `Matte · ${quote.sides === 2 ? 'both sides' : 'one side'}`
        : 'Glossy';
    if (customBoardPriceEl) customBoardPriceEl.textContent = formatPkr(quote.board);
    if (customFinishLabelEl) customFinishLabelEl.textContent = finishText;
    if (customFinishPriceEl) {
      customFinishPriceEl.textContent = quote.finishCharge > 0 ? formatPkr(quote.finishCharge) : 'Free';
    }
    if (customFeePriceEl) {
      customFeePriceEl.textContent = quote.fee > 0 ? formatPkr(quote.fee) : 'Included';
    }
    if (customFeeNoteEl) {
      customFeeNoteEl.textContent = quote.standard
        ? '30″ × 20″ horizontal: no separate customization fee.'
        : customState.orientation === 'Square pegboard'
          ? 'Square pegboard. The customization fee applies.'
          : 'Size or shape is not 30″ × 20″ horizontal, so the customization fee applies.';
    }
    if (customShippingPriceEl) customShippingPriceEl.textContent = formatPkr(quote.delivery);
    if (priceCalcTotal) priceCalcTotal.textContent = formatPkr(quote.total);
    if (customSpecsEl) {
      customSpecsEl.innerHTML = `
        <div><strong>Size</strong> · ${escapeHtml(String(customState.length))}" × ${escapeHtml(String(customState.width))}"</div>
        <div><strong>Shape</strong> · ${escapeHtml(customState.orientation)}</div>
        <div><strong>Colour</strong> · ${escapeHtml(customState.color)}</div>
        <div><strong>Finish</strong> · ${escapeHtml(finishText)}</div>
      `;
    }
    const totalLabel = qs('[data-price-calc-total-label]');
    if (totalLabel) totalLabel.textContent = customState.business ? 'Price each' : 'Estimated total';
    return quote;
  };

  const resolveCustomVariantId = async () => {
    const fromDrawer = priceCalcDrawer?.dataset.customVariantId;
    const fromSection = buildSection?.dataset.customVariantId;
    if (fromDrawer) return fromDrawer;
    if (fromSection) return fromSection;

    // Bootstrap product via worker if checkout key is present.
    const workerUrl = (buildSection?.dataset.workerUrl || '').replace(/\/$/, '');
    const checkoutKey =
      buildSection?.dataset.checkoutKey ||
      qs('[data-bank-xfer-root]')?.dataset?.checkoutKey ||
      '';
    if (workerUrl && checkoutKey) {
      try {
        const res = await fetch(`${workerUrl}/ensure-custom-pegboard`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Skadeas-Key': checkoutKey,
          },
          body: '{}',
        });
        const data = await res.json();
        if (res.ok && data?.product?.variant_id) {
          const id = String(data.product.variant_id);
          if (priceCalcDrawer) priceCalcDrawer.dataset.customVariantId = id;
          if (buildSection) buildSection.dataset.customVariantId = id;
          return id;
        }
      } catch (err) {
        console.error(err);
      }
    }

    // Storefront fallback by handle.
    try {
      const res = await fetch(`/products/${CUSTOM_BOARD_HANDLE}.js`);
      if (res.ok) {
        const product = await res.json();
        const id = product?.variants?.[0]?.id;
        if (id) {
          if (priceCalcDrawer) priceCalcDrawer.dataset.customVariantId = String(id);
          return String(id);
        }
      }
    } catch (err) {
      console.error(err);
    }
    return '';
  };

  priceCalcLength?.addEventListener('input', syncSizeContinue);
  priceCalcWidth?.addEventListener('input', syncSizeContinue);
  qsa('[data-custom-orientation]').forEach((el) => {
    el.addEventListener('change', syncOrientationContinue);
  });
  qsa('[data-custom-color]').forEach((el) => {
    el.addEventListener('change', syncColorContinue);
  });
  qsa('[data-custom-finish], [data-custom-sides]').forEach((el) => {
    el.addEventListener('change', syncFinishContinue);
  });
  customPolicyAck?.addEventListener('change', syncReviewAck);

  const rememberDimensions = () => {
    const { length, width } = currentDimensions();
    customState.length = length.value || 0;
    customState.width = width.value || 0;
  };

  qsa('[data-custom-next]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const next = btn.getAttribute('data-custom-next');
      if (next === 'orientation') {
        if (!sizeValid()) return;
        rememberDimensions();
        if (applySquareOrientation()) {
          syncColorContinue();
          showCustomStep('color');
          return;
        }
        showCustomStep('orientation');
        return;
      }
      if (next === 'color') {
        syncOrientationContinue();
        if (!customState.orientation) return;
        rememberDimensions();
        syncColorContinue();
        showCustomStep('color');
        return;
      }
      if (next === 'finish') {
        syncColorContinue();
        if (!customState.color) return;
        syncFinishContinue();
        showCustomStep('finish');
        return;
      }
      if (next === 'review') {
        syncFinishContinue();
        if (customState.finish !== 'Glossy' && !(customState.finish === 'Matte' && customState.sides > 0)) return;
        computeCustomTotal();
        syncReviewAck();
        showCustomStep('review');
      }
    });
  });

  qsa('[data-custom-back]').forEach((btn) => {
    btn.addEventListener('click', () => {
      let back = btn.getAttribute('data-custom-back');
      if (back === 'orientation' && customState.orientation === 'Square pegboard') back = 'size';
      if (back) showCustomStep(back);
    });
  });

  // Reset wizard whenever the drawer opens (after open animation tick).
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open="price-calc"]');
    if (!opener) return;
    window.setTimeout(() => {
      customState.business = Boolean(opener.hasAttribute('data-custom-business'));
      priceCalcDrawer?.classList.toggle('is-business', customState.business);
      const businessQtyRow = qs('[data-custom-business-qty-row]');
      const businessNote = qs('[data-custom-business-note]');
      if (businessQtyRow) businessQtyRow.hidden = !customState.business;
      if (businessNote) businessNote.hidden = !customState.business;
      const businessQty = qs('[data-custom-business-qty]');
      if (businessQty) businessQty.value = '1';
      if (customAddBtn) customAddBtn.textContent = customState.business ? 'Add to corporate order' : 'Add to Cart';
      if (priceCalcLength) priceCalcLength.value = '';
      if (priceCalcWidth) priceCalcWidth.value = '';
      qsa('[data-custom-orientation], [data-custom-color], [data-custom-finish], [data-custom-sides]').forEach((el) => {
        el.checked = false;
      });
      if (customPolicyAck) {
        customPolicyAck.checked = false;
        customPolicyAck.removeAttribute('aria-invalid');
        customPolicyAck.closest('.sk-price-calc__ack')?.classList.remove('is-invalid');
      }
      const ackError = qs('[data-custom-ack-error]');
      if (ackError) ackError.hidden = true;
      if (customPolicyPopup) customPolicyPopup.hidden = true;
      customState.orientation = '';
      customState.color = '';
      customState.finish = '';
      customState.sides = 0;
      customState.length = 0;
      customState.width = 0;
      customState.total = 0;
      syncSizeContinue();
      syncOrientationContinue();
      syncColorContinue();
      syncFinishContinue();
      syncReviewAck();
      showCustomStep('size');
    }, 30);
  });

  customAddBtn?.addEventListener('click', async () => {
    // Prefer live DOM selections so Add to Cart stays in sync with the visible choices.
    syncOrientationContinue();
    syncColorContinue();
    syncFinishContinue();
    if (!customPolicyAck?.checked) {
      markPolicyAckError();
      return;
    }
    const finishReady =
      customState.finish === 'Glossy' || (customState.finish === 'Matte' && customState.sides > 0);
    if (!sizeValid() || !customState.orientation || !customState.color || !finishReady) {
      if (!sizeValid()) showCustomStep('size');
      else if (!customState.orientation) showCustomStep('orientation');
      else if (!customState.color) showCustomStep('color');
      else showCustomStep('finish');
      return;
    }
    const quote = computeCustomTotal();
    if (customErrorEl) {
      customErrorEl.hidden = true;
      customErrorEl.textContent = '';
    }
    const original = customAddBtn.textContent;
    customAddBtn.disabled = true;
    customAddBtn.textContent = customState.business ? 'Adding…' : 'Adding…';
    try {
      const variantId = await resolveCustomVariantId();
      if (!variantId) {
        throw new Error(
          'Custom pegboard product is not ready yet. Please refresh and try again, or contact support.',
        );
      }
      const finishLabel =
        customState.finish === 'Matte'
          ? `Matte · ${customState.sides === 2 ? 'both sides' : 'one side'}`
          : 'Glossy';
      if (customState.business) {
        const qty = Math.max(1, Math.min(500, Math.floor(Number(qs('[data-custom-business-qty]')?.value) || 1)));
        const unitPkr = quote.board + quote.finishCharge;
        document.dispatchEvent(
          new CustomEvent('skadeas:business-board', {
            detail: {
              variantId: String(variantId),
              quantity: qty,
              unitPkr,
              title: `Custom pegboard ${customState.length}" × ${customState.width}" · ${customState.color} · ${customState.orientation} · ${finishLabel}`,
              custom: {
                length: customState.length,
                width: customState.width,
                orientation: customState.orientation,
                color: customState.color,
                finish: customState.finish,
                sides: customState.sides,
              },
            },
          }),
        );
        closeDrawer('price-calc');
        return;
      }
      const addUrl = window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart/add.js`
        : '/cart/add.js';
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: {
                Custom: 'Custom pegboard',
                Size: `${customState.length}" × ${customState.width}"`,
                Orientation: customState.orientation,
                Colour: customState.color,
                Finish:
                  customState.finish === 'Matte'
                    ? `Matte · ${customState.sides === 2 ? 'both sides' : 'one side'}`
                    : 'Glossy',
                'Customization fee': quote.fee > 0 ? formatPkr(quote.fee) : 'Included',
                Delivery: formatPkr(quote.delivery),
                _custom_board: '1',
                _quoted_pkr: String(Math.round(quote.total)),
              },
            },
          ],
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data?.description || data?.message || 'Could not add custom order to cart.');
      }
      closeDrawer('price-calc');
      await renderCartDrawer();
      openDrawer('cart');
      pubsub.emit('cart:updated');
    } catch (err) {
      console.error(err);
      if (customErrorEl) {
        customErrorEl.hidden = false;
        customErrorEl.textContent = err?.message || 'Could not add to cart.';
      } else {
        window.alert(err?.message || 'Could not add to cart.');
      }
    } finally {
      customAddBtn.disabled = false;
      customAddBtn.textContent = original;
    }
  });

  const closePolicyPopup = () => {
    if (customPolicyPopup) customPolicyPopup.hidden = true;
  };

  const openPolicyPopup = async (kind) => {
    if (!customPolicyPopup || !customPolicyBody) return;
    const isDelivery = kind === 'delivery';
    const url = isDelivery ? '/pages/delivery-policy' : '/pages/custom-order-policy';
    if (customPolicyTitle) customPolicyTitle.textContent = isDelivery ? 'Delivery policy' : 'Custom order policy';
    customPolicyPopup.hidden = false;
    customPolicyBody.innerHTML = '<p>Loading…</p>';
    try {
      if (!policyCache[url]) {
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        policyCache[url] = doc.querySelector('.sk-policy__body')?.innerHTML || '';
      }
      customPolicyBody.innerHTML = policyCache[url] || '<p>Could not load this policy. Please try again.</p>';
      customPolicyBody.querySelectorAll('[data-sk-reveal]').forEach((el) => el.classList.add('is-inview'));
      customPolicyBody.scrollTop = 0;
    } catch (err) {
      console.error(err);
      customPolicyBody.innerHTML = '<p>Could not load this policy. Please try again.</p>';
    }
  };

  document.addEventListener('click', (e) => {
    const popupBtn = e.target.closest('[data-policy-popup]');
    if (popupBtn) {
      e.preventDefault();
      e.stopPropagation();
      openPolicyPopup(popupBtn.getAttribute('data-policy-popup'));
      return;
    }
    if (e.target.closest('[data-custom-policy-close]')) {
      e.preventDefault();
      closePolicyPopup();
      return;
    }
    const policyLink = e.target.closest('[data-custom-policy-body] a');
    if (!policyLink) return;
    const href = policyLink.getAttribute('href') || '';
    if (href.includes('/pages/delivery-policy')) {
      e.preventDefault();
      openPolicyPopup('delivery');
    } else if (href.includes('/pages/custom-order-policy')) {
      e.preventDefault();
      openPolicyPopup('custom');
    } else if (!policyLink.target || policyLink.target === '_self') {
      e.preventDefault();
    }
  });

  const initTestimonialsCarousel = (root) => {
    const track = qs('[data-testimonials-track]', root);
    const viewport = qs('[data-testimonials-viewport]', root);
    const prevBtn = qs('[data-testimonials-prev]', root);
    const nextBtn = qs('[data-testimonials-next]', root);
    const cards = qsa('.sk-testimonial', track);
    if (!track || !viewport || !cards.length) return;

    let index = 0;

    const perView = () => {
      const raw = getComputedStyle(root).getPropertyValue('--sk-testimonials-per-view');
      const n = Number.parseInt(raw, 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    };

    const maxIndex = () => Math.max(0, cards.length - perView());

    const render = () => {
      const n = perView();
      const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      const cardWidth = Math.max(0, (viewport.clientWidth - gap * (n - 1)) / n);
      cards.forEach((card) => {
        card.style.width = `${cardWidth}px`;
        card.style.flex = `0 0 ${cardWidth}px`;
      });

      index = Math.min(Math.max(0, index), maxIndex());
      const offset = index * (cardWidth + gap);
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
    };

    prevBtn?.addEventListener('click', () => {
      index -= 1;
      render();
    });
    nextBtn?.addEventListener('click', () => {
      index += 1;
      render();
    });

    window.addEventListener('resize', render, { passive: true });
    render();
  };

  const stripProductWhatsAppCtas = (root = document) => {
    qsa('[data-sk-product-description]', root).forEach((container) => {
      qsa('style, meta', container).forEach((el) => el.remove());
      qsa('a[href*="whatsapp.com"], a[href*="wa.me/"]', container).forEach((a) => {
        const wrap = a.closest('.cta, .pre115544');
        (wrap || a).remove();
      });
      qsa('.pre115544', container).forEach((el) => el.remove());
      qsa('.cta', container).forEach((el) => {
        const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text && !el.querySelector('img')) {
          el.remove();
          return;
        }
        if (el.querySelector('img') && !text) {
          el.replaceWith(...el.childNodes);
        }
      });
    });
  };
  stripProductWhatsAppCtas();

  qsa('[data-testimonials-carousel]').forEach(initTestimonialsCarousel);

  qsa('[data-sk-video-loop], .sk-video video').forEach((video) => {
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    const ensurePlay = () => {
      video.loop = true;
      const playAttempt = video.play();
      if (playAttempt?.catch) playAttempt.catch(() => {});
    };
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      ensurePlay();
    });
    video.addEventListener('pause', () => {
      if (video.ended || video.currentTime >= video.duration - 0.05) {
        video.currentTime = 0;
        ensurePlay();
      }
    });
    ensurePlay();
  });

  // Hero video: inline script in sk-hero.liquid starts playback immediately.
  // Keep a deferred backup for theme editor / late hydration.
  qsa('[data-sk-hero-video]').forEach((video) => {
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;
    const tryPlay = () => {
      video.muted = true;
      const attempt = video.play();
      if (attempt?.catch) attempt.catch(() => {});
    };
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      tryPlay();
    });
    tryPlay();
  });

  // Framer-like scroll reveals (policy pages and reusable elsewhere)
  const initSkReveals = () => {
    const nodes = qsa('[data-sk-reveal]');
    if (!nodes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach((el) => el.classList.add('is-inview'));
      return;
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach((el) => el.classList.add('is-inview'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    // Reveal above-the-fold items immediately so the page never feels blank.
    nodes.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) {
        el.classList.add('is-inview');
      } else {
        observer.observe(el);
      }
    });
  };
  initSkReveals();

  // —— VPN gate: block browsing until VPN/proxy is off ——
  const initVpnGate = () => {
    const gate = qs('[data-vpn-gate]');
    if (!gate) return;
    // Never lock the theme editor or design mode.
    if (window.Shopify?.designMode) return;

    const checkUrl = gate.getAttribute('data-vpn-check-url');
    if (!checkUrl) return;

    const statusEl = gate.querySelector('[data-vpn-gate-status]');
    const dialog = gate.querySelector('.sk-vpn-gate__dialog');
    let pollTimer = 0;
    let blocked = false;

    const setStatus = (text) => {
      if (statusEl) statusEl.textContent = text;
    };

    const lock = () => {
      if (blocked) return;
      blocked = true;
      gate.hidden = false;
      gate.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sk-vpn-blocked');
      setStatus('Waiting for VPN to disconnect…');
      window.setTimeout(() => dialog?.focus?.(), 50);
    };

    const unlock = () => {
      if (!blocked) return;
      blocked = false;
      gate.hidden = true;
      gate.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sk-vpn-blocked');
      setStatus('Checking connection…');
      if (pollTimer) {
        window.clearInterval(pollTimer);
        pollTimer = 0;
      }
    };

    // Trap Escape / back — gate is intentionally uncloseable.
    document.addEventListener(
      'keydown',
      (e) => {
        if (!blocked) return;
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          e.stopPropagation();
        }
        // Keep focus inside the dialog.
        if (e.key === 'Tab') {
          e.preventDefault();
          dialog?.focus?.();
        }
      },
      true,
    );

    const check = async () => {
      try {
        const res = await fetch(checkUrl, {
          method: 'GET',
          credentials: 'omit',
          cache: 'no-store',
        });
        if (!res.ok) return; // fail open
        const data = await res.json();
        if (data?.vpn) {
          lock();
          if (!pollTimer) {
            pollTimer = window.setInterval(check, 15000);
          }
        } else {
          unlock();
        }
      } catch {
        // fail open
      }
    };

    check();
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check();
    });
  };
  initVpnGate();

  // Music floater: primary autoplay logic lives inline in sk-music-floater.liquid
  // (runs before deferred JS). Keep a tiny backup unlock hook here.
  if (window.__skMusic?.unmute) {
    ['pointerdown', 'touchstart', 'click'].forEach((evt) => {
      document.addEventListener(evt, () => window.__skMusic.unmute(), {
        once: true,
        passive: true,
        capture: true,
      });
    });
  }
})();
